"use client";
import { cn } from "@/lib/utils";
import Portal from "./globalPortal";
import { IMilitaryInquiryItem } from "@/interfaces";
import { CustomButton, FlexBetween } from "@/components/ui";
import { BdAltArrowLeft, BdCloseCircle } from "solar-icon-react/bd";

import MilitaryServices from "@/components/services/governmental/militaryServices";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  services: IMilitaryInquiryItem[];
  onSubmit: () => void;
  setSampleService: (service: any) => void;
  onInquirySelect: (inquiry: IMilitaryInquiryItem) => void;
  selectedInquiry: IMilitaryInquiryItem; // Add this prop
}

export default function MilitaryRelatedServicesModal({
  isOpen,
  onClose,
  services,
  onSubmit,
  onInquirySelect,
  setSampleService,
  selectedInquiry, // Receive from parent
}: Props) {
  // Remove local state - now controlled by parent
  const handleInquirySelect = (inquiry: IMilitaryInquiryItem) => {
    onInquirySelect(inquiry);
  };
  const allServicesInactive = services?.every(
    (item) => item.status !== "active",
  );
  return (
    <Portal>
      <div
        className={cn("fixed inset-0 z-50 flex items-center justify-center")}
      >
        <div
          className={cn(
            "fixed inset-0 bg-black/50 transition-opacity duration-300",
          )}
          onClick={onClose}
        />
        <div
          className={cn(
            "relative z-50 mx-8 w-full max-w-md overflow-hidden rounded-xl bg-white shadow-xl sm:mx-0",
          )}
        >
          {/* Header */}
          <FlexBetween
            className={cn("bg-primary-main border-b px-6 py-3 text-white")}
          >
            <h2 className={cn("")}>انتخاب سرویس</h2>
            <BdCloseCircle
              onClick={onClose}
              size={25}
              className={cn("cursor-pointer text-white!")}
            />
          </FlexBetween>
          <div className="mt-3 px-4 pt-3">
            <MilitaryServices
              selectedInquiry={selectedInquiry}
              setSampleService={setSampleService}
              setSelectedInquiry={handleInquirySelect}
              services={services}
            />
          </div>
          <div className="my-10 flex justify-center">
            <CustomButton
              className={cn("w-full max-w-[190px] px-2!")}
              onClick={onSubmit}
              loadingLabel="inquiring"
              id="military-services-next-step"
              icon={<BdAltArrowLeft size={20} />}
              iconPosition="end"
              disabled={allServicesInactive}
            >
              مرحله بعد
            </CustomButton>
          </div>
        </div>
      </div>
    </Portal>
  );
}
